import { useFilterUtilCategoryContext } from "./filter-util-category.context";

export function FilterUtilCategory() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterUtilCategoryContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}